import { useBooleanFlagValue } from '@openfeature/react-sdk'
import { useReselector } from '@/utils/sharedHooks'
import { FEATURE_FLAG_KEYS } from '@/features/open-feature'
import {
  selectCurrentAnnualTaxFiling,
  selectIsEligibleForCurrentYearTaxServices,
  selectShowDashboardTaxSeasonHeroBanner,
} from '@/features/taxes/annual-taxes/annualTaxFilings.selector'
import { useIsTaxSeasonOpen } from '@/features/taxes/annual-taxes/useIsTaxSeasonOpen'

/**
 * Whether the dashboard shows the tax season card. Null while the tax season
 * flags load, for a customer whose card depends on them.
 */
export const useShowTaxKickoffCard = (): boolean | null => {
  const shouldShowHeroBanner = useReselector(
    selectShowDashboardTaxSeasonHeroBanner
  )
  const disable2024AnnualTax = useBooleanFlagValue(
    FEATURE_FLAG_KEYS.disable2024AnnualTax,
    false
  )
  const annualTaxFiling = useReselector(selectCurrentAnnualTaxFiling)
  const isEligibleForTaxServices = useReselector(
    selectIsEligibleForCurrentYearTaxServices
  )
  const isTaxSeasonOpen = useIsTaxSeasonOpen()

  const tskSubmitted = Boolean(annualTaxFiling?.pretaxSurveySubmittedAt)
  return (
    shouldShowHeroBanner &&
    !disable2024AnnualTax &&
    !annualTaxFiling?.disqualifiedAt &&
    !annualTaxFiling?.optedOutAt &&
    isEligibleForTaxServices &&
    (tskSubmitted || isTaxSeasonOpen)
  )
}
